<div class="basicrow f-black roboto-r f-reg m-top-ii text-center">
        <div class="shortcont">
            <div class="basicrow bg-gray-u-i allpads bordsdef m-top-ii roboto-b text-justify">
                Mant&eacute;n actualizado tu correo electr&oacute;nico por el cual podr&aacute;s recibir tu factura de manera electr&oacute;nica.
            </div>

            <div class="basicrow m-top-i">
                <div class="basicrow">
                    <label class="label-f" >
                        &#42; Correo Electr&oacute;nico Actual
                    </label>

                    <input class="inp-f off" [(ngModel)]="this.email">
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f" >
                        &#42; Nuevo Correo Electr&oacute;nico
                    </label>

                    <input placeholder="Ingresa el nuevo correo" class="inp-f" [(ngModel)]="this.email1">
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Confirmar Correo Electr&oacute;nico
                    </label>

                    <input placeholder="Confirma el nuevo correo" class="inp-f" [(ngModel)]="this.email2">
                </div>
            </div>

            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>

            <div class="basicrow m-top-i text-center">
                <a class="btns def-iv red centr vcenter">
                    <span class="tabcell" (click)="this.continueEmail();this.submitted==true; ">
                        Guardar Cambios&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>